import {
  GET_PRODUCT_SUB_CATEGORIES,
  SET_PRODUCT_SUB_CATEGORIES,
  API_ERROR,
  SET_PRODUCT_SUB_CATEGORY,
  SET_PRODUCT_SUB_CATEGORY_FILTER,
  EMPTY_PRODUCT_SUB_CATEGORY,
  SET_PRODUCT_SUB_CATEGORIES_LIST,
} from "./actionTypes";

const initialState = {
  productSubCategoriesList: [],
  productSubCategories: [],
  filter: {
    offSet: 0,
    limit: 10,
    pages: 0,
    currentPage: 1,
    query: "",
  },
  productSubCategory: {
    parent_id: '',
    category_name: "",
  },
  error: "",
  loading: false,
};

const productSubCategory = (state = initialState, action) => {
  switch (action.type) {
    case GET_PRODUCT_SUB_CATEGORIES:
      state = {
        ...state,
        loading: true,
      };
      break;
    case SET_PRODUCT_SUB_CATEGORIES:
      state = {
        ...state,
        productSubCategories: action.payload,
        loading: false,
      };
      break;
    case SET_PRODUCT_SUB_CATEGORY:
      state = {
        ...state,
        productSubCategory: {
          ...state.productSubCategory,
          [action.payload.field]: action.payload.value,
        },
      };
      break;
    case EMPTY_PRODUCT_SUB_CATEGORY:
      state = {
        ...state,
        productSubCategory: {
          ...state.productSubCategory,
          parent_id: '',
          category_name: "",
        },
      };
      break;
    case SET_PRODUCT_SUB_CATEGORY_FILTER:
      state = {
        ...state,
        filter: {
          ...state.filter,
          [action.payload.field]: action.payload.value,
        },
      };
      break;
    case SET_PRODUCT_SUB_CATEGORIES_LIST:
      state = {
        ...state,
        productSubCategoriesList: action.payload,
      };
      break;
    case API_ERROR:
      state = { ...state, error: action.payload, loading: false };
      break;
    default:
      state = { ...state };
      break;
  }
  return state;
};

export default productSubCategory;
